import React from "react";
import { ExternalLink } from "lucide-react";
import { NotifyForm } from "@/components/merch/NotifyForm";

const POSTER = "https://customer-assets-7cd3h4nn.emergentagent.net/job_wolf-cinematic/artifacts/hb248w9u_image.png";
const BUY_URL = "https://wolfandphillyvapes.com.au";

const FLAVOURS = [
  { id: "ocean-mist", name: "Ocean Mist", tag: "Clean. Crisp. Limitless." },
  { id: "gold-coast", name: "Gold Coast", tag: "Good vibes always." },
  { id: "purple-sky", name: "Purple Sky", tag: "Higher things ahead." },
  { id: "no-limits", name: "No Limits", tag: "Same crew. Different view." },
];

export const WolfPhillySection = () => (
  <section className="mt-24" data-testid="wolf-philly-section">
    <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37] mb-5">— Wolf &amp; Philly · Freedom In Every Puff</p>
    <h2 className="font-display wolf-gold-foil text-4xl sm:text-6xl leading-none">Wolf &amp; Philly Vape</h2>
    <p className="font-editorial italic text-lg text-white/50 mt-4 max-w-xl">
      Higher vibes. Cleaner days. No limits. Same crew — different view.
    </p>

    <div className="mt-10 grid lg:grid-cols-5 gap-6 sm:gap-8 items-stretch">
      <div className="lg:col-span-3 border border-[#D4AF37]/25 bg-black overflow-hidden">
        <img
          src={POSTER}
          alt="Wolf & Philly Vape — Freedom in every puff"
          loading="lazy"
          className="w-full h-full object-cover"
          data-testid="wolf-philly-poster"
        />
      </div>

      <div className="lg:col-span-2 flex flex-col border border-white/10 bg-[#0d0d0d]">
        <div className="p-6 sm:p-8 flex-1">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80">— The Flavours</p>
          <div className="mt-5 space-y-4">
            {FLAVOURS.map((f) => (
              <div key={f.id} className="flex items-baseline justify-between gap-4 border-b border-white/10 pb-4" data-testid={`wolf-philly-flavour-${f.id}`}>
                <p className="font-display text-xl sm:text-2xl text-white">{f.name}</p>
                <p className="text-[11px] uppercase tracking-[0.22em] text-white/40 text-right">{f.tag}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-[10px] uppercase tracking-[0.25em] text-white/35">
            <span>Smooth Draw</span><span>6000 Puffs</span><span>Long Lasting</span><span>Rich Flavours</span><span>Premium Quality</span>
          </div>
        </div>
        <div className="p-6 sm:p-8 border-t border-white/10">
          <a
            href={BUY_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="wolf-philly-buy-link"
            className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-black bg-[#D4AF37] hover:bg-[#e6c457] px-7 py-4 transition-colors font-bold"
          >
            Where To Buy <ExternalLink size={14} />
          </a>
          <p className="mt-4 text-[10px] uppercase tracking-[0.22em] text-white/30">
            18+ only · Sold separately via Wolf &amp; Philly · Est. 2026
          </p>
          <div className="mt-5 border-t border-white/10 pt-5">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-3">— Get notified when it drops</p>
            <NotifyForm testIdPrefix="vape-notify" productId="wolf-philly-vape" />
          </div>
        </div>
      </div>
    </div>
  </section>
);
